import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {
  IRapportSousSystemeRaw,
  RapportSousSystemRaw,
} from '../../_models/RapportSousSysteme';

export const name = 'rapportSousSystemes';

export interface RapportSousSystemeState
  extends EntityState<IRapportSousSystemeRaw> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectRapportSousSysteme(a: IRapportSousSystemeRaw): any {
  return a.id;
}

function sortById(
  a: IRapportSousSystemeRaw,
  b: IRapportSousSystemeRaw
): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IRapportSousSystemeRaw> =
  createEntityAdapter<IRapportSousSystemeRaw>({
    selectId: selectRapportSousSysteme,
    sortComparer: sortById,
  });

const initialState: RapportSousSystemeState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: false,
});

/* ACTION */
export const loadRapportSousSystemesAction = createAction(
  '[RapportSousSysteme] Load RapportSousSystemes'
);
export const loadRapportSousSystemesErrorAction = createAction(
  '[RapportSousSysteme] Load RapportSousSystemes Error'
);
export const loadRapportSousSystemesSuccessAction = createAction(
  '[RapportSousSysteme] Load RapportSousSystemes Success',
  props<{ payload: IRapportSousSystemeRaw[] }>()
);
export const setRapportsSousSystemesAction = createAction(
  '[RapportSousSysteme] Set RapportSousSysteme',
  props<{ payload: IRapportSousSystemeRaw[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadRapportSousSystemesAction, (state) => {
    return { ...state, loading: true };
  }),
  on(loadRapportSousSystemesErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(loadRapportSousSystemesSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(setRapportsSousSystemesAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function rapportSousSystemeReducer(
  state: RapportSousSystemeState | undefined,
  action: Action
): RapportSousSystemeState {
  return reducer(state, action);
}

/* SELECTOR */
const selectRapportSousSystemeState =
  createFeatureSelector<RapportSousSystemeState>(name);

const isInitialized = (state: RapportSousSystemeState) => state.isInitialized;
const isLoading = (state: RapportSousSystemeState) => state.loading;

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const selectAllRapportSousSystemes = createSelector(
  selectRapportSousSystemeState,
  (state) => {
    return state.loading
      ? []
      : state.ids.map(
          (id: any) => new RapportSousSystemRaw(state.entities[id])
        );
  }
);
export const getIsRapportSousSystemeInitialized = createSelector(
  selectRapportSousSystemeState,
  isInitialized
);
export const getIsRapportSousSystemeLoading = createSelector(
  selectRapportSousSystemeState,
  isLoading
);
